import React from 'react';
import { Modal } from '@gerdau/hefesto';

import { ModalOverlay } from './styles';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { updateQueryParam } from '../../../../utils/updateQueryParams';
import { ERoutes } from '../../../../routes';
import { EPurchaseRoutes } from '../../../Purchase/purchase.routes';
import { EOrderTab } from '../../../../store/ducks/long-steel-orders/types';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import moment from 'moment';

export const UpateItemsFinished = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const finished = params.get('changes') === 'finished';

  if (!finished) {
    return null;
  }

  const history = useHistory();
  const dispatch = useDispatch();

  const updateItemsState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders.updateItems
  );
  const ordersState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders
  );
  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );

  const activeTabState = ordersState[ordersState.tableType || EOrderTab.OPEN];

  React.useEffect(() => {
    dispatch(
      sendTagging({
        event: 'alteracoes_confirmada',
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor: activeTabState.initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            activeTabState.initialInputValues.emitterIds.includes(
              item.customerId
            )
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio: moment(activeTabState.initialInputValues.startDate).format(
          'DD/MM/YYYY'
        ),
        data_fim: moment(activeTabState.initialInputValues.endDate).format(
          'DD/MM/YYYY'
        )
      })
    );
  }, []);

  const handleClose = () => {
    updateQueryParam('changes');
    return history.push(`${ERoutes.ORDERS}/${EPurchaseRoutes.LONG_STEEL}`);
  };

  return (
    <ModalOverlay width={368}>
      <Modal
        title={`Sua solicitação de alterações de ${
          updateItemsState.itemsSelected.length
        } ite${
          updateItemsState.itemsSelected.length > 1 ? 'ns' : 'm'
        } foi enviada`}
        modalSize="sm"
        buttons={{
          right: {
            name: 'button-close-finished-items-update',
            children: 'Fechar',
            onClick: handleClose,
            type: 'button'
          }
        }}
      >
        <span>
          Sua solicitação será analisada e respondida em até 3 dias úteis.
        </span>
      </Modal>
    </ModalOverlay>
  );
};
